import router from "@/router"
import httpRequest from "@/services/httpRequest"

export default ({
    namespaced: true,
    state: {
        recruitmentLiability: null,
        studentPaymentCode: null,
        eduLiability: null,
        otherLiability: null,
        carts: [],
        chanelList: [],
        midtransCode: null,
        paymentHistories: [],
        isLoading: false,
        errorMessage: null,
        selectedPayment: null
    },
    mutations: {
        SET_RECRUITMENT_LIABILITY(state, data) {
            state.recruitmentLiability = data.liability
        },
        SET_STUDENT_LIABILITY(state, data) {
            //console.log('SET_STUDENT_LIABILITY data = ', data)
            state.eduLiability = data.edu_liability	
            state.otherLiability = data.other_liability	
            state.isLoading = false
        },
        SET_STUDENT_PAYMENTCODE(state, data) {
            state.studentPaymentCode = data.results[0]?.code_nosep
        },
        SET_PAYMENT_LIST(state, data) {
            state.chanelList = data.channels
        },

        SET_MIDTRANS_CODE(state, data) {
            state.midtransCode = data.token
        },

        SET_PAYMENT_HISTORY(state, data) {
            state.paymentHistories = data.results
            state.isLoading = false
        },
    },
    actions: {
        async getRecruitmentLiability({ rootState, commit, state }, params) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/paymentcode/recruitment_liability`,
                    method: 'POST',
                    data: {
                        payment_code: rootState.auth.profileData.payment_code,
                    }
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (res.status === 200) {
                commit('SET_RECRUITMENT_LIABILITY', res.data)
                state.isLoading = false
            } else {
                //console.log('getPayment res = ', res)
                state.isLoading = false
            }
        },

        async getPaymentCode({ rootState, commit }, params) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/paymentcode`,
                    method: 'GET',
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (res.status === 200) {
                commit('SET_STUDENT_PAYMENTCODE', res.data)
            } else {
                //console.log('getPayment res = ', res)
            }
        },

        async getStudentLiability({ rootState, commit, state }, params) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/paymentcode/liability`,
                    method: 'POST',
                    data: {
                        payment_code: state.studentPaymentCode,
                    }
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (res.status === 200) {
                commit('SET_STUDENT_LIABILITY', res.data)
            } else {
                //console.log('getPayment res = ', res)
            }
        },

        async getChanelList({ rootState, commit }) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/onlinepaymentorder/channel_list`,
                    method: 'GET',
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (res.status === 200) {
                commit('SET_PAYMENT_LIST', res.data)
            } else {
                //console.log('chanel list = ', res)
            }
        },

        async generateVA({ rootState, state, commit }, data) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/paymentcode/order`,
                    method: 'POST',
                    data: data
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (data.channel === 'MIDTRANS') {
                if (res.status === 200) {
                    commit('SET_MIDTRANS_CODE', res.data)
                    rootState.isLoading = false
                    return true
                } else {
                    if (res.status == 400) {
                        state.errorMessage = res.data.message
                    } else {
                        state.errorMessage = "Terjadi kesalahan server, coba sesaat lagi!"
                    }
                    rootState.isLoading = false
                    return false
                }  
            }

            if (data.channel === 'BRI') {
                if (res.status === 200) {
                    state.selectedPayment = res.data
                    rootState.isLoading = false
                    router.replace({path: '/history-payment-finance'})
                    return true
                } else {
                    if (res.status == 400) {
                        state.errorMessage = res.data.message
                    } else {
                        state.errorMessage = "Terjadi kesalahan server, coba sesaat lagi!"
                    }
                    rootState.isLoading = false
                    return false
                }   
            }
        },

        async getPaymentHistory({ rootState, commit, state }) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/onlinepaymentorder?rows=999&payment_code=${state.studentPaymentCode}`,
                    method: 'GET',
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (res.status === 200) {
                commit('SET_PAYMENT_HISTORY', res.data)
            } else {
                //console.log('getPaymentHistory res = ', res)
            }
        }
    }
})